import {Button} from '@/components/ui/button/Button'
import {DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {FC, useState} from 'react'
import {useDialogContext, useDialogStore} from '@ariakit/react'
import {AddConsultantAbsenceFormValidationSchema} from '../../formSchemas'
import {useFormContext} from 'react-hook-form'
import {ConsultantAbsenceConfirmationDialog} from '../consultant-absence-confirmation-dialog/ConsultantAbsenceConfirmationDialog'

export const AddConsultantAbsenceDialogFooter: FC = () => {
    const parentDialogStore = useDialogContext()
    if (!parentDialogStore) {
        throw new Error('parentDialogStore is not found')
    }
    const {t} = useTranslation()
    const [isConfirmOpen, setIsConfirmOpen] = useState(false)
    const {handleSubmit, getValues} = useFormContext<AddConsultantAbsenceFormValidationSchema>()
    const confirmationDialogStore = useDialogStore({
        open: isConfirmOpen,
        setOpen: setIsConfirmOpen
    })

    const onConfirm = handleSubmit(
        () => {
            setIsConfirmOpen(true)
        },
        errors => {
            console.error('validation errors:', errors)
        }
    )

    return (
        <DialogFooter>
            <Flexbox gap={2} justify="end" fullWidth>
                <Button variant="secondary" onClick={() => parentDialogStore.setOpen(false)}>
                    {t('commons:close')}
                </Button>
                <Button variant="primaryNeutral" onClick={onConfirm}>
                    {t('commons:confirm')}
                </Button>
            </Flexbox>
            {isConfirmOpen && (
                <ConsultantAbsenceConfirmationDialog
                    defaultValues={getValues()}
                    dialogStore={confirmationDialogStore}
                />
            )}
        </DialogFooter>
    )
}
